if (typeof goaDpEnhancer == "undefined") {
    goaDpEnhancer = {};
}

goaDpEnhancer.log = function (msg) {
    console.log("[GOA-Log]: " + msg);
};

goaDpEnhancer.genTopContent = function () {
    return "<div class='goa-dp-helper-top'><p>Pick a start date 1-2 days before your event</p></div>";
};

goaDpEnhancer.genBotContent = function () {
    var botMsg = "*Choose pickup or delivery in the next step";
    var botHelperContent =
        "" +
        "<div class='goa-dp-helper-bottom'>" +
        "<div class='goa-dp-legend-container'>" +
        "<div class='goa-dp-legend goa-dp-legend-start' style=''>" +
        "<i class='date-sign-wrapper'>" +
        "<i class='date-sign-indicator date-sign-indicator-start'></i>" +
        "</i>" +
        "<p class='goa-dp-legend-message'>" +
        "<strong>PICK UP / DELIVERY </strong>" +
        "<span>by 5pm</span>" +
        "</p>" +
        "</div>" +
        "<div class='goa-dp-legend goa-dp-legend-end'>" +
        "<i class='date-sign-wrapper'>" +
        "<i class='date-sign-indicator date-sign-indicator-end'></i>" +
        "</i>" +
        "<p class='goa-dp-legend-message'>" +
        "<strong>DROP OFF / POST BACK </strong>" +
        "<span>today</span>" +
        "</p>" +
        "</div>" +
        "<div class='goa-dp-legend goa-dp-legend-unavailable'>" +
        "<i class='date-sign-wrapper unavailable'>" +
        "</i>" +
        "<p class='goa-dp-legend-message'>" +
        "<span>Date</span>" +
        "<span>is</span>" +
        "<span>unavailable</span>" +
        "</p>" +
        "</div>" +
        "</div>" +
        "<div class='goa-dp-bot-helper-message'>" +
        "<p>" +
        botMsg +
        "</p>" +
        "</div>" +
        "</div>";
    return botHelperContent;
};

enhanceDatepicker = function () {
    _this = this;
    if (!jQuery || !jQuery.datepicker) {
        _this.log("JQuery, JQuery-Datepicker is not installed!");
        return;
    }

    var $dp = $("#ui-datepicker-div, .bta-inline-datepicker .ui-datepicker-inline");

    if ($dp.length == 0) {
        _this.log("datepicker has not yet initialized!");
        return;
    }

    var $input = $("input.datepicker.bta.bta-range-start");

    if ($input.length != 1) {
        _this.log("Something wrong with input!");
        return;
    }

    var $form = $('form[action^="/cart/add"]');
    if ($form.length == 0) {
        _this.log("Add to cart Form not found!");
        return;
    }

    var btaForm = $form.data("bta.bookingForm");
    if (!btaForm) {
        _this.log("btaForm not found!");
        return;
    }

    // mouse enter and mouse leave
    jQ("#ui-datepicker-div, .bta-inline-datepicker .ui-datepicker-inline").on(
        {
            mouseenter: function (event) {
                var cell = jQ(this),
                    start = new Date(parseInt(cell.attr("data-year"), 10), parseInt(cell.attr("data-month"), 10), parseInt(cell.text(), 10)),
                    finish = btaForm.addDuration(start),
                    days = bta.dayDelta(start, finish),
                    variant = btaForm.currentVariant(),
                    allDay = variant ? variant.allDay : 0;

                if (btaForm.isCountNights() && !allDay) {
                    days += 1;
                }

                var $firstHoverCell = $dp.find(".ui-datepicker-calendar td .ui-state-hover:eq(0)");
                $firstHoverCell.siblings("i.date-sign-indicator-start").addClass("current");

                // number of cells to highlight = (number of difference days between start and finish) + 1
                var lastHoverCellIndex = days;

                var $lastHoverCell = $dp.find(".ui-datepicker-calendar td .ui-state-hover:eq(" + lastHoverCellIndex + ")");
                $lastHoverCell.siblings("i.date-sign-indicator-end").addClass("current");
            },
            mouseleave: function () {
                $dp.find(".ui-datepicker-calendar td > i.date-sign-indicator.current").removeClass("current");
            },
        },
        '.ui-datepicker-calendar td[data-handler="selectDay"]'
    );

    var topHelperContent = _this.genTopContent();
    var botHelperContent = _this.genBotContent();

    $input.on("focus", function () {
        $dp.find("table.ui-datepicker-calendar").attr("id", "goa-enhanced");

        var topHelperExisted = $dp.children(".goa-dp-helper-top").length != 0;
        if (!topHelperExisted) {
            $dp.prepend(topHelperContent);
        }

        var botHelperExisted = $dp.children(".goa-dp-helper-bottom").length != 0;
        if (!botHelperExisted) {
            $dp.append(botHelperContent);
        }

        $dateCell = $dp.find("table.ui-datepicker-calendar tr td");

        if ($dateCell.find("i").length == 0) {
            $dateCell.append("<i class='date-sign-indicator date-sign-indicator-start'></i'>");
            $dateCell.append("<i class='date-sign-indicator date-sign-indicator-end'></i'>");
        }
    });
};

// bta.formLoaded event is dispatched by bookthatapp

if (window.attachEvent) {
    document.querySelector('form[action^="/cart/add"]').addEventListener("bta.formLoaded", function () {
        enhanceDatepicker.apply(goaDpEnhancer);
    });
} else {
    document.querySelector('form[action^="/cart/add"]').addEventListener("bta.formLoaded", function () {
        enhanceDatepicker.apply(goaDpEnhancer);
    });
}
